<template>
    <v-container fluid v-resize="resize" :style="{ height: height + 'px' } + 'background-color: #F6F8FE'">
        <v-row class="pb-8" id="wellcome" justify="center">
            <v-col v-if="!$vuetify.breakpoint.smAndDown"
                class="align-center py-1 d-flex justify-center pl-md-2 mt-md-6">
                <v-icon class="mr-2" size="80" color="primary">mdi-human-greeting-variant</v-icon>
                <h1 id="welcome" class="v-row-text">
                    Bienvenido/a {{ fullName }}
                </h1>
            </v-col>
            <v-col v-if="$vuetify.breakpoint.smAndDown" class="align-center py-1 d-flex justify-center pl-md-2 mt-md-6"
                style="text-align: center">
                <h1 id="welcome" class="v-row-text">
                    Bienvenido/a {{ fullName }}
                </h1>
            </v-col>
        </v-row>
        <v-row v-if="!hasManagerPermission" class="mt-md-1">
            <v-col md="6" cols="12" class="pa-0">
                <Scheduled />
                <v-col cols="12">
                    <v-dialog ref="dialog2" v-model="modal2" :return-value.sync="selectMonth" persistent width="680px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field class="me-8" v-model="selectMonth" label="Selecciona un mes"
                                messages="Por defecto el ranking de comercial es de todos los tiempos"
                                prepend-icon="mdi-calendar-cursor" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker type="month" full-width scrollable v-model="date2" :max="
                                new Date(
                                    Date.now() -
                                        new Date().getTimezoneOffset() * 60000
                                )
                                    .toISOString()
                                    .substr(0, 10)
                            ">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal2 = false">
                                Cancelar
                            </v-btn>
                            <v-btn text color="primary" @click="$refs.dialog2.save(date2)">
                                Aceptar
                            </v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-col>
                <DashBoardSelfObjectives />
            </v-col>
            <v-col class="mt-n3" md="6" cols="12">
                <v-row class="mt-4 mx-2">
                    <v-dialog ref="dialog" v-model="modal" :return-value.sync="selectedDay" persistent width="580px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="selectedDay" label="Selecciona una fecha" prepend-icon="mdi-calendar"
                                readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="date" full-width range :max="
                                new Date(
                                    Date.now() -
                                        new Date().getTimezoneOffset() * 60000
                                )
                                    .toISOString()
                                    .substr(0, 10)
                            " scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal = false">
                                Cancelar
                            </v-btn>
                            <v-btn text color="primary" @click="$refs.dialog.save(date)">
                                Aceptar
                            </v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-row>
                <v-row class="mt-md-n5 px-3">
                    <v-col md="6" cols="12">
                        <v-row>
                            <DashBoardProductivity />
                        </v-row>
                    </v-col>
                    <v-col md="6" cols="12" class="mt-n3">
                        <DashBoardYoigonotesState />
                    </v-col>
                </v-row>
                <v-row justify="start">
                    <v-col cols="12">
                        <DashBoardTopComerciales v-if="!isComercialCobOrRec" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row justify="start" v-if="hasManagerPermission" class="mb-n6 pa-4">
            <v-col sm="12" md="5">
                <v-dialog ref="dialog2" v-model="modal2" :return-value.sync="selectMonth" persistent width="680px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="selectMonth" label="Selecciona un mes"
                            messages="Por defecto el ranking de comercial es de todos los tiempos, y la cobertura del mes actual"
                            prepend-icon="mdi-calendar-cursor" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker type="month" full-width scrollable v-model="date2" :max="
                            new Date(
                                Date.now() -
                                    new Date().getTimezoneOffset() * 60000
                            )
                                .toISOString()
                                .substr(0, 10)
                        ">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal2 = false">
                            Cancelar
                        </v-btn>
                        <v-btn text color="primary" @click="$refs.dialog2.save(date2)">
                            Aceptar
                        </v-btn>
                    </v-date-picker>
                </v-dialog>
            </v-col>
        </v-row>
        <v-row v-if="hasManagerPermission">
            <v-col md="6" lg="6" cols="12">
                <Scheduled v-if="hasOnlyManagerPermission" class="mb-4" />
                <DashBoardTopComerciales />
            </v-col>
            <v-col md="6" cols="12">
                <v-row>
                    <v-col cols="12">
                        <DashBoardShopObjectives />
                    </v-col>
                </v-row>
                <v-row class="mx-2">
                    <v-col cols="12" class="pa-0">
                        <v-dialog ref="dialog" v-model="modal" :return-value.sync="selectedDay" persistent
                            width="580px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="selectedDay" label="Selecciona una fecha"
                                    prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="date" full-width range :max="
                                    new Date(
                                        Date.now() -
                                            new Date().getTimezoneOffset() *
                                                60000
                                    )
                                        .toISOString()
                                        .substr(0, 10)
                                " scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modal = false">
                                    Cancelar
                                </v-btn>
                                <v-btn text color="primary" @click="$refs.dialog.save(date)">
                                    Aceptar
                                </v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                </v-row>
                <v-row class="mt-md-n5">
                    <v-col lg="6" cols="12">
                        <DashBoardProductivity />
                    </v-col>
                    <v-col lg="6" cols="12">
                        <DashBoardYoigonotesState />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <div id="fullHeigth"></div>
    </v-container>
</template>

<script>
import DashBoardShopObjectives from '@/components/DashBoard/DashBoardShopObjectives.vue';
import DashBoardProductivity from '@/components/DashBoard/DashBoardProductivity.vue';
import DashBoardTopComerciales from '@/components/DashBoard/DashBoardTopComerciales.vue';
import DashBoardYoigonotesState from '@/components/DashBoard/DashBoardYoigonotesState.vue';
// import DashBoardPieChart from '@/components/DashBoard/pDashBoardPieChart.vue'
import DashBoardSelfObjectives from '@/components/DashBoard/DashBoardSelfObjectives.vue';
import Scheduled from '@/components/DashBoard/DashBoardScheduled.vue';

import { mapState, mapGetters } from 'vuex';
// import Home from '../../views/Home.vue';

export default {
    name: 'DashBoard',
    components: {
        DashBoardShopObjectives,
        DashBoardProductivity,
        DashBoardTopComerciales,
        DashBoardYoigonotesState,
        //       DashBoardPieChart,
        DashBoardSelfObjectives,
        Scheduled,
        // Home,
    },
    data: () => ({
        height: 100,
        modal: false,
        modal2: false,
        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        date2: null,
    }),
    computed: {
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
            hasComercialPermission: 'hasComercialPermission',
            hasOnlyManagerPermission: 'hasOnlyManagerPermission',
            isComercialCobOrRec: 'isComercialCobOrRec',
        }),
        ...mapState('login', {
            fullName: (state) => state.nombre,
        }),
        selectedDay: {
            get() {
                if (
                    Array.isArray(this.$store.state.dashboard.selectedDay) &&
                    this.$store.state.dashboard.selectedDay.length > 1
                ) {
                    this.$store.state.dashboard.selectedDay.sort(function (
                        a,
                        b
                    ) {
                        a = new Date(a);
                        b = new Date(b);
                        return a > b ? 1 : a < b ? -1 : 0;
                    });
                    const [year, month, day] =
                        this.$store.state.dashboard.selectedDay[0].split('-');
                    const [year2, month2, day2] =
                        this.$store.state.dashboard.selectedDay[1].split('-');
                    return (
                        `${day}/${month}/${year}` +
                        ' ~ ' +
                        `${day2}/${month2}/${year2}`
                    );
                } else {
                    return this.$store.state.dashboard.selectedDay;
                }
            },
            set(val) {
                this.$store.commit('dashboard/selectedDay', val);
            },
        },
        selectMonth: {
            get() {
                return this.$store.state.dashboard.selectMonth;
            },
            set(val) {
                if (val) {
                    if (val.includes('~')) {
                        val = val.split(' ~ ');
                    }

                    this.$store.commit('dashboard/selectMonth', val);
                }
            },
        },
    },
    methods: {
        resize() {
            this.height =
                // document.getElementById('control-height').clientHeight -
                48 - 15;
        },
        goToAccount() {
            this.$router.push({ name: 'miZona' });
        },
    },
    beforeCreate() {
        if (this.hasComercialPermission || this.hasOnlyManagerPermission)
            this.$store.commit('dashboard/isLoadingestadisticaAgendados', true);
        this.$store.commit('dashboard/isLoadingestadisticaConsecucion', true);
        this.$store.commit('dashboard/isLoadingestadisticaRanking', true);
        setTimeout(() => {
            if (this.hasComercialPermission || this.hasOnlyManagerPermission)
                this.$store.dispatch('dashboard/fetchAgendados');
            this.$store.dispatch('dashboard/fetchConsecucion');
            this.$store.dispatch('dashboard/fetchRanking');
        }, 100);
        // this.$store.dispatch('dashboard/getDashboardInfo');
        // this.$store.dispatch('dashboard/init');
    },
    watch: {
        selectMonth: {
            handler() {
                this.$store.commit(
                    'dashboard/isLoadingestadisticaRanking',
                    true
                );
                this.$store.commit(
                    'dashboard/isLoadingestadisticaConsecucion',
                    true
                );
                setTimeout(() => {
                    this.$store.dispatch('dashboard/fetchRanking');
                    this.$store.dispatch('dashboard/fetchConsecucion');
                }, 100);
            },
        },
        selectedDay: {
            immediate: true,
            handler() {
                this.$store.commit(
                    'dashboard/isLoadingEstadisticaVentas',
                    true
                );
                this.$store.commit(
                    'dashboard/isLoadingestadisticaAccionesComerciales',
                    true
                );
                setTimeout(() => {
                    this.$store.dispatch('dashboard/fetchTipoVentaCount');
                    this.$store.dispatch(
                        'dashboard/fetchEstadisticaAccionesComerciales'
                    );
                }, 100);
            },
        },
    },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Zen+Kurenaido&display=swap');

#welcome {
    font-size: 50px;
    font-family: 'Roboto Slab';
}

#control-height {
    height: 100vh;
    width: 0;
    position: fixed;
}

#fullHeigth {
    height: 100vh;
    width: 0;
    position: absolute;
}

.vcard-text {
    font-size: 30px;
    font-family: 'Roboto Condensed', sans-serif;
}

.vcard-text-sm {
    font-size: 25px;
    font-family: 'Roboto Condensed', sans-serif;
}

.numeral-text {
    font-weight: bold;
    font-size: 15px;
    font-family: 'Zen Kurenaido', sans-serif;
}

.numeral-text-2 {
    font-weight: bold;
    font-size: 25px;
    font-family: 'Zen Kurenaido', sans-serif;
}

.numeral-text-3 {
    font-weight: bold;
    font-size: 40px;
    font-family: 'Zen Kurenaido', sans-serif;
}

#center {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0;
}
</style>